import { Injectable } from '@angular/core';
import swal, { SweetAlertType } from 'sweetalert2';

export interface Swal {
  title?: string,
  text: string,
  type?: SweetAlertType,
  showCancelButton?: boolean,
  confirmButtonColor?: string,
  cancelButtonColor?: string,
  confirmButtonText?: string,
  cancelButtonText?: string,
  handlerConfirm?: any,
  handlerCancel?: any,
  timer?: number
}

@Injectable()
export class AlertService {

  openSwal(data: Swal) {
    swal({
      title: data.title,
      html: data.text,
      type: data.type
    }).catch(swal.noop);
  }

  openConfirmsSwal(data: Swal) {
    swal({
      title: data.title,
      html: data.text,
      type: data.type,
      showCancelButton: data.showCancelButton,
      confirmButtonColor: data.confirmButtonColor,
      cancelButtonColor: data.confirmButtonColor,
      confirmButtonText: data.confirmButtonText,
      cancelButtonText: data.cancelButtonText
    }).then((result) => {
      if (result.value) {
        data.handlerConfirm();
      } else {
        if (data.handlerCancel) {
          data.handlerCancel();
        }
      }
    });
  }

  openCloseAuto(data: Swal) {
    swal({
      title: data.title || 'Espere un momento..!',
      html: data.text || '',
      type: data.type || 'success',
      timer: data.timer,
      onBeforeOpen: () => {
        swal.showLoading();
      },
    }).then((result) => {
      if (result.dismiss === swal.DismissReason.timer) {
        console.log('I was closed by the timer')
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/alert.service.ts